import $ from 'jquery';

const $searchPopup = $('#search-popup');

$searchPopup.find('.search-popup__tab').on('click', ev => {
    ev.preventDefault();
    let $link = $(ev.currentTarget);
    let $target = $($link.attr('href'));

    $searchPopup.find('.search-popup__tab')
        .removeClass('active');
    $link.addClass('active');

    $searchPopup.find('.search-popup__tab-content')
        .removeClass('active');
    $target.addClass('active');

    let $input = $target.find('input[type="search"], input[type="text"]');
    if ($input.length > 0) {
        window.setTimeout(() => $input[0].focus(), 100);
    }
});

$('a.open-search-popup').on('click', ev => {
    ev.preventDefault();
    let hash = ev.currentTarget.hash;
    if (!hash) {
        hash = '#general-search';
    }

    $.magnificPopup.open({
        items: {
            src: $searchPopup,
            type: 'inline'
        },
        callbacks: {
            beforeOpen: function () {
                if (hash) {
                    let $tab = $searchPopup.find('.search-popup__tab[href="' + hash + '"]');
                    $tab.trigger('click');
                }
            }
        }
    });

});
